import { Action, Dispatch } from 'redux'
import { REHYDRATE } from 'redux-persist/lib/constants'

import { User } from '../../lib/interfaces/User.interface'

import * as appActions from '../app/actions'
import { TokenSetAction, actionTypes, authError, setUser, tokenSave, setAuthStatus } from './actions'

import { hydrateApi } from '../../lib/api'
import { getCurrentUser } from '../../lib/api/auth'

const { createLogic } = require('redux-logic')

type OnDoneType = () => void

type RehydrateActionType = {
  payload: {
    auth: {
      accessToken: string
    }
  }
}

const onRehydrateLogic = createLogic({
  type: REHYDRATE,
  process({ action }: { action: RehydrateActionType }, dispatch: Dispatch, done: OnDoneType) {

    if (action.payload) {
      const { auth } = action.payload

      if (auth.accessToken) {
        dispatch(tokenSave(auth.accessToken))
      }
    }

    done()
  }
})

const onTokenSaveLogic = createLogic({
  type: actionTypes.AUTH_TOKEN_SET,
  cancelType: actionTypes.AUTH_LOGOUT,
  process({ action }: { action: TokenSetAction }, dispatch: Dispatch, done: OnDoneType) {
    const { accessToken, next } = action.payload

    hydrateApi(accessToken)

    getCurrentUser()
      .then((user: any) => {
        dispatch(setUser(user as User))

        dispatch(appActions.fetchLocationsSuccessDispatchCommand(user.locations))
        dispatch(setAuthStatus('authed'))

        if (next) {
          next(null, user as User)
        }
      })
      .catch(({ message }: { message: string }) => {
        dispatch(authError(message))

        if (next) {
          next(message)
        }
      })
      .then(() => done())
  }
})

const onTokenClearLogic = createLogic({
  type: actionTypes.AUTH_LOGOUT,
  process({ action }: { action: Action }, dispatch: Dispatch, done: OnDoneType) {
    hydrateApi(undefined)
    done()
  }
})

export const authLogicList = [
  onRehydrateLogic,
  onTokenClearLogic,
  onTokenSaveLogic,
]



// WEBPACK FOOTER //
// ./src/store/auth/logic.ts